export default __webpack_public_path__ + "static/media/instagram.6d2de74d.svg";